import { ICorpResponse } from 'src/types/Corp';
import { sdk } from 'src/utilities/sdk';

export async function getCorpData(corpId: string): Promise<ICorpResponse> {
  try {
    return await sdk.http.get(`/corps/${corpId}`);
  } catch (error) {
    return Promise.reject();
  }
}
